export default {
    COMMON: {
        SITE: "Site | Sites",
        SILO: "Silo | Silos",
        SECTION: "Section | Sections",
        DESCRIPTION: "Description",
        TEMPERATURE: "Temperature",
        HUMIDITY: "Humidity",
        MOISTURE: "Grain Moisture",
        MOISTABLE: "Moisture",
        CO2: "CO2",
        SAVE: "Save",
        CANCEL: "Cancel",
        LAST_SYNC: "Last Report",
        SAVE_SUCCESS: "Save Success",
        SAVE_FAILURE: "Ups.. an error occurred",
        NO_DATA: "No Data",
        BACK_DASHBOARD: "Back to Dashboard",
        CLICK_SILO: "Double click to view silo details",
        STATUS: "Status",
        SILO_DETAILS: "Show details",
        CLOSE: "Close"
    },
    GRAIN: {
        SOJA: "Soy",
        MAIZ: "Corn",
        CEBADA: "Barley",
        TRIGO: "Wheat",
        GIRASOL: "Sunflower",
        CENTENO: "Rye",
        POROTO: "Bean",
        ARROZ: "Rice"
    },
    SIDEBAR: {
        HISTORICS: "Historical Report",
        METRICS: "Metrics",
        CONFIGS: "Configurations",
        DAILY_REPORT: "Last Data",
        DASHBOARD: "Dashboard",
        ANALYTICS: "Analytics",
        RISK_ANALYSIS: "Risk Analysis",
        //INSURANCE: "Cotiza tu Seguro"
        INSURANCE: "Insurance"
        
    },
    LOGIN: {
        USERNAME: "User",
        USERNAME_REQUIRED: "Please complete username",
        PASSWORD_REQUIRED: "Please complete password",
        PASSWORD: "Password",
        WELCOME: "Welcome !",
        SIGN_IN: "Sign in"
    },
    NAVBAR: {
        PROFILE: "Profile",
        LOGOUT: "Logout",
        ADMIN: "Admin",
    },
    MONITOR: {
        WARNING_DETAILS: "Warning details",
        SILO_DATA: "Silo data"
    },
    PROFILE: {
        CELSIUS: "Celsius [C°]",
        FAHRENHEITS: "Fahrenheits [F]",
        PPM: "Parts per million [ppm]",
        PERCENTAGE: "Percent [%]",
        USER_DATA: "User Information",
        USER_PROFILE: "User Profile",
        UNITS_DEFAULT: "Default Units",
        NAME: "Name",
        LAST_NAME: "Last Name",
        CONTACT_PHONE: "Phone",
        EMAIL: "email",
        UNITS: "Units",
        CHANGE_PASSWORD: "Change Password",
        NEW_PASSWORD: "New Password",
        FILL_NEW_PASSWORD: "Fill the new Password",
        LOGOUT: "Logout",
        LOGOUT_MESSAGE: "To see the updated changes you need to login again",
        CONF_CHANGE: "Configuration change",
        SILO_DETAIL_ENABLE: "Silo detail enabled",
        SILO_DETAIL_DISABLE: "Silo detail disabled",
        CONTINUE: "Continue",
        SILO_DETAIL: "Silo Detail",
        TIMEZONE: "Timezone",
        CONFIRM_PASSWORD: "Confirm Password",
        FILL_NEW_PASSWORD: "Please enter a new password",
        FILL_CONFIRM_PASSWORD: "Please re-enter your password",
        MAX_LENGTH_EXCEEDED: "Password cannot be longer than 44 characters",
        PASSWORDS_DO_NOT_MATCH: "Passwords do not match",
        PASSWORD_CHANGE_CANCELLED: "Password change cancelled",
        EDIT_MESSAGE: "Please use the new Web to edit your profile. For any questions, please contact Wiagro"
    },
    RISK_ANALYSIS: {
        TITLE: "Risk Analysis",
        NO_SECTIONS: "This silo has no sensors",
        LOW: "Low",
        MEDIUM: "Medium",
        HIGH: "High",
        VERY_HIGH: "Very high"
    },
    CONFIGS: {
        CONFIGS: "Configurations",
        SUBTITLE: "Configure the thresholds for every grain"
    },
    ERROR: {
        1: "Interface version missing",
        2: "Command missing",
        3: "Some parameters are missing",
        4: "Wrong command",
        5: "Ups.. an error occurred",
        6: "The http methods is not valid for the command selected",
        7: "Interface version not found",
        8: "The command its declared but the service is not implemented yet",
        9: "Wrong user or password",
        10: "Session expired",
        11: "Wrong parameter in the request",
        12: "Maximum concurrent sessions exceeded",
        13: "The site does not belong to the user",
        14: "Session does not exists for this user",
        15: "The site does not have associated silos",
        16: "Didnt found any silo for the indicated site",
        COMMUNICATION_FAILURE: 'Communication failure',
        OUTDATED: 'Outdated'
    },
    REPORTS: {
        DAILY_REPORT: "Daily Report",
        NO_SECTIONS: "This silo has no sensors",
        NO_DATA: "No Data",
        NO_DATA_FOR_DATE_AND_SILO: "No changes for this {silo} and selected date",
        PICK_A_DATE: "Select a date",
        LAST_DATA: "Last Data",
        STATUS_COLOR: "Status color",
        BAGGED_DATE: "Date bagged: ",
        INI_MOISTURE: "Initial grain moisture: ",
        TONS: "Tons: ",
        SILO_DATA: "Silo data",
        SILO_DETAILS: "Silo details",
        SENSOR_FAIL: "Sensor failure",
    },
    HISTORICS: {
        HISTORICS: "Historical Report",
        DATE_FROM: "From",
        DATE_TO: "To",
        NO_SITES: "There are no sites created yet",
        SILO_WITH_NO_SENSORS: "This silo has no sensor",
        PICK_A_DATE: "Select a date",
        NO_DATA_FOR_THIS_DATE: "No data for this date",
        SECTION_NAME: "Section {section}"

    },
    STATUS: {
        NO_DATA: "No Data",
        OK: "Ok",
        WARN: "Measurement out of established range",
        ERROR: "Measurement in critical ranges",
        DISABLED: "Disabled"

    },
    INDICATOR: {
        OK: "Ok",
        DANGER: "Danger",
        WARN: "Warning",
        NO_DATA: "No Data",
    },
    EVENTS: {
        MOV: "Movement waring",
        STAT_TEMP: "Current temperature status: {status}",
        STAT_CO2: "Current CO2 status: {status}",
        STAT_HUM: "Current humidity status: {status}",
        STAT_HUM_GRANO: "Current grain moisture status: {status}",
        NO_EVENTS: "No Warnings",
        BREAK_BAG: "Possible bag break",
        AVERY_BAG: "Possible bag opening",
        HUM_ALERT: "Moisture alert"        

    },
    el: {
        select: {
            noData: "No data",
            placeholder: "Pick an option"
        },
        table: {
            confirmFilter: "Confirm",
            resetFilter: "Reset"
        },
        datepicker: {
            now: "now",
            today: "Today",
            cancel: "Cancel",
            clear: "clear",
            confirm: "Confirm",
            selectDate: "Pick a date",
            selectTime: "Pick an hour",
            startDate: "Start date",
            startTime: "Start time",
            endDate: "End date",
            endTime: "End Time",
            prevYear: "Previous year",
            nextYear: "Next year",
            prevMonth: "Previous month",
            nextMonth: "Next Month",
            year: "",
            month1: "January",
            month2: "February",
            month3: "March",
            month4: "April",
            month5: "May",
            month6: "June",
            month7: "July",
            month8: "August",
            month9: "September",
            month10: "October",
            month11: "November",
            month12: "December",
            month: 'Month',
            week: 'Week',
            weeks: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat'
            },
            months: {
                jan: 'jan',
                feb: 'feb',
                mar: 'mar',
                apr: 'apr',
                may: 'may',
                jun: 'jun',
                jul: 'jul',
                aug: 'aug',
                sep: 'sep',
                oct: 'oct',
                nov: 'nov',
                dec: 'dec'
            }
        }
    }
};